module.exports = __webpack_public_path__ + "img/pijltje-dropdown.ecfbe2e15976d28b6387a69d7bf71d25.svg";